/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Forside_Safe_3_BodyInputs */

const da_forside_safe_3_body = /** @type {(inputs: Forside_Safe_3_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Login med godkendt konto. Hver lærer ser kun sine egne prøver og klasser.`)
};

/** @type {(inputs: Forside_Safe_3_BodyInputs) => LocalizedString} */
const en_forside_safe_3_body = da_forside_safe_3_body;

/**

* @param {Forside_Safe_3_BodyInputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const forside_safe_3_body = /** @type {((inputs?: Forside_Safe_3_BodyInputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forside_Safe_3_BodyInputs, { locale?: "da" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_forside_safe_3_body(inputs)
	return /** @type {LocalizedString} */ ("Login med godkendt konto. Hver lærer ser kun sine egne prøver og klasser.")
});